(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InitSetupController', InitSetupController);

    InitSetupController.$inject = ['$scope', 'WizardHandler', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'WizardService', 'ServiceCategoryCustom', 'CompanyCustom'];

    function InitSetupController($scope, WizardHandler, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, WizardService, ServiceCategoryCustom, CompanyCustom) {
        var vm = this;
        vm.wizardData;
        vm.isCompanyInfoValid = false;
        vm.isScheduleInfoValid = false;
        vm.isServiceItemValid = false;
        vm.isBusy = false;
        vm.initWizardData = initWizardData;
        vm.saveWizardData = saveWizardData;
        vm.nextFromStep = nextFromStep;
        vm.isStepValid = isStepValid;
        vm.prevFromStep = prevFromStep;
        vm.initWizardData();
        vm.setScheduleInfoValid = function setScheduleInfoValid(isvalid) {
            vm.isScheduleInfoValid = isvalid;
        }
        vm.setCompanyInfoValid = function setCompanyInfoValid(isvalid) {
            vm.isCompanyInfoValid = isvalid;
        }
        vm.setServiceItemValid = function setServiceItemValid(isvalid) {
            vm.isServiceItemValid = isvalid;
        }


        function nextFromStep() {

            var wizard = WizardHandler.wizard();
            var currentStep = wizard.currentStepNumber();
            if (vm.isStepValid(currentStep)) {
                //end step
                if (currentStep == 3) {
                    vm.saveWizardData(function (savedDate) {
                        vm.wizardData = savedDate;
                        vm.isBusy = false;
                        addGTagData();
                        wizard.next();
                        Principal.setCurrentCompany(vm.wizardData.company);
                    }, function (error) {
                        vm.isBusy = false;
                    });
                } else {
                    wizard.next();
                }
            }
        }

        function prevFromStep() {
            var wizard = WizardHandler.wizard();
            wizard.previous();
        }

        function isStepValid(stepNumber) {
            switch (stepNumber) {
                case 1:
                    return vm.isCompanyInfoValid;
                case 2:
                    return vm.isScheduleInfoValid;
                case 3:
                    return vm.isServiceItemValid;
            }

        }

        function initWizardData() {

            //CompanyCustom.getCurrentCompany().query().$promise.then(function(result){
            //    if(result != null && result != undefined )
            //    {
            //        if(result.title !=null && result.title !=undefined &&result.title != '')
            //        {
            //            $state.go('supplierPanel.dashboard');
            //        }
            //    }
            //})
            vm.wizardData = {};
            vm.wizardData.serviceItem = {};
            vm.wizardData.serviceItems = [];
            vm.wizardData.serviceItems.push(vm.wizardData.serviceItem);
            vm.wizardData.newServant = {};
            vm.wizardData.newServant.personInfo = {};
            vm.wizardData.newServant.personInfo.fisrtName = null;

        }

        function collectWizardData() {
            vm.wizardData.serviceItems[0] = vm.wizardData.serviceItem;
        }

        function saveWizardData(onSuccess, onFail) {
            vm.isBusy = true;
            collectWizardData();

            return WizardService.saveInitSetup().save(vm.wizardData, onSuccess, onFail);
        }


        function SetDataByActivityType() {

            if (vm.wizardData.company == null || vm.wizardData.company == undefined)
                return;
            if (vm.wizardData.company.activityType == 'WORK_SPACE') {
                vm.wizardData.serviceItem.itemTitle = 'رزرو به صورت ساعتی';
                vm.wizardData.serviceItem.duration = 60;
                vm.wizardData.serviceItem.minPrice = 0.0;
            }
        }

        function addGTagData() {


            var activityType = 'NOT_SET';
            if (vm.wizardData.company && vm.wizardData.company.activityType) {
                activityType = vm.wizardData.company.activityType;
            }

            try {
                //user Free Account Started
                if (gtag()) {
                    gtag('event', 'freemium_start', {
                        "items": [
                            {
                                "id": "PL102",
                                "name": "14 Days Free Account",
                                "list_name": "",
                                "brand": "Planovin",
                                "category": vm.wizardData.company.activityType,
                                "price": '0'
                            }
                        ]
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }

        $scope.$watch('vm.wizardData.company.activityType', function () {

            SetDataByActivityType();
        });


    }
})();
